import { Grid, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { GridCard } from "components/atoms";
import _ from "lodash";
import React, { Fragment, useEffect } from "react";

interface IDetailTableProps {
  title?: string;
  headerButtons?: React.ReactNode;
  descriptions?: string;
  tabsName: string[];
  tabsPanel: React.ReactNode[];
  hideHeaderButton?: boolean;
  getTabNumber?(tab: number): void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const a11yProps = (index: number) => {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
};

const DetailTableTabs = (props: IDetailTableProps) => {
  const {
    headerButtons,
    tabsName,
    tabsPanel,
    hideHeaderButton = false,
    getTabNumber,
  } = props;
  const [value, setValue] = React.useState(0);
  useEffect(() => {
    getTabNumber && getTabNumber(value);
  }, []);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    getTabNumber && getTabNumber(newValue);
    setValue(newValue);
  };

  return (
    <GridCard sx={{ display: "flex", flex: 1 }}>
      {!hideHeaderButton && <Header headerButtons={headerButtons} />}
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        {!_.isEmpty(tabsName) && (
          <Box
            sx={{ borderBottom: 1, borderColor: "divider", padding: "0 16px" }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              {tabsName.map((x, i) => (
                <Tab label={`${x}`} {...a11yProps(i)} />
              ))}
            </Tabs>
          </Box>
        )}
        {tabsPanel.map((x, i) => (
          <TabPanel value={value} index={i}>
            {x}
          </TabPanel>
        ))}
      </Box>
    </GridCard>
  );
};

const Header = (props: { headerButtons?: React.ReactNode }) => {
  return (
    <Grid container p={2}>
      <Stack direction={"row"} spacing={2}>
        {props.headerButtons}
      </Stack>
    </Grid>
  );
};
const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ height: "100%", flex: 1 }}
      {...other}
    >
      {value === index && <Fragment>{children}</Fragment>}
    </div>
  );
};

export default DetailTableTabs;
